export const testOrgs = {
  EAQFCF04TR: {
    isVerified: true,
    followers: 152,
    description: `Tony's Game Shop offers a curated selection of the best board games, collectible card games, and miniatures games in the area. We host weekly events for Magic: The Gathering, Dungeons & Dragons, and Warhammer 40k. Come join us for a game!`,
    gameSystems: [
      { name: "Magic: The Gathering", id: 1 },
      { name: "Dungeons & Dragons", id: 2 },
      { name: "Warhammer 40k", id: 3 },
      { name: "Age of Sigmar", id: 4 },
      { name: "One Piece", id: 5 },
      { name: "Kill Team", id: 3 },
      { name: "Yu-Gi-Oh!", id: 6 },
    ],
    profileUrl:
      "https://i.postimg.cc/HsYx6FsB/85383fa2-68d7-46c9-b4ff-fc4c0d8f6ec2.jpg",
  },
  PESde141wtyH: {
    isVerified: true,
    followers: 454,
    description:
      "GAMA is the Game Manufacturers Association. We are the non-profit trade organization serving the hobby games industry. Our members include publishers, manufacturers, distributors, retailers, and suppliers of tabletop games.",
    gameSystems: [
      { name: "Magic: The Gathering", id: 1 },
      { name: "Dungeons & Dragons", id: 2 },
      { name: "Warhammer 40k", id: 3 },
      { name: "Age of Sigmar", id: 4 },
      { name: "One Piece", id: 5 },
      { name: "Kill Team", id: 3 },
      { name: "Yu-Gi-Oh!", id: 6 },
      { name: "Pokemon", id: 7 },
      { name: "Vanguard", id: 8 },
    ],
    profileUrl:
      "https://i.postimg.cc/gJyzDHCC/650x650-aa16b10174e2fa0e292255f50449455b66b0d9090efbcd422747e452.png",
  },
  "5K8miOJFXxFO": {
    followers: 953,
    description: `Angel City Games is a Los Angeles-based hobby and game store that specializes in card games. We host weekly events for Magic: The Gathering, Yu-Gi-Oh!, Pokemon, and many more. Come join us for a game!`,
    gameSystems: [
      { name: "Magic: The Gathering", id: 1 },
      { name: "Pokemon", id: 2 },
      { name: "Yu-Gi-Oh!", id: 3 },
      { name: "Digimon", id: 4 },
      { name: "One Piece", id: 5 },
      { name: "Dragon Ball Super", id: 6 },
      { name: "Vanguard", id: 7 },
      { name: "Weiss Schwarz", id: 8 },
    ],
    profileUrl:
      "https://i.postimg.cc/0N93csDZ/1c05666c-2d3c-49e9-9ec9-e9c791e8ee31.jpg",
  },
};
